import { GoogleAdapter } from '../google-adapter/index.esm.js';
import { MapboxAdapter } from '../mapbox-adapter/index.esm.js';

/**
 * @deprecated This file is deprecated and should no longer be used or modified.
 * Please use shared UI adapters or an updated adapter factory implementation instead.
 */
const thirdPartyAdapterRegister = {
  google: GoogleAdapter,
  mapbox: MapboxAdapter
};
/**
 * @deprecated
 */
class ThirdPartyAdapterFactory {
  static getInstance(k, locale, apiKey, version) {
    return thirdPartyAdapterRegister[k].getInstance(locale, apiKey, version);
  }
  static filterThirdPartyAdapterFromEssConfig(configFeaturesList) {
    return configFeaturesList.filter(v => v in thirdPartyAdapterRegister);
  }
}
export { ThirdPartyAdapterFactory };